import React, { useEffect, useRef } from "react";
import "./Services.css";

const ServicesPage = () => {
  const cardRefs = useRef([]);

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add("flip-in");
          } else {
            entry.target.classList.remove("flip-in");
          }
        });
      },
      {
        threshold: 0.1,
        rootMargin: "0px",
      }
    );

    cardRefs.current.forEach((card) => {
      if (card) observer.observe(card);
    });

    return () => {
      cardRefs.current.forEach((card) => {
        if (card) observer.unobserve(card);
      });
    };
  }, []);

  const services = [
    { className: "custom-design" },
    { className: "free-shipping" },
    { className: "lifetime-warranty" },
    { className: "jewelry-repair" },
  ];

  return (
    <div className="services-container">
      <h1 className="services-title">Our Services</h1>
      <div className="services-grid">
        {services.map((service, index) => (
          <div
            key={index}
            className={`service-card ${service.className}`}
            ref={(el) => (cardRefs.current[index] = el)}
          />
        ))}
      </div>
    </div>
  );
};

export default ServicesPage;
